// @flow
import * as React from 'react';
import {
  BreadcrumbCurrent,
  BreadcrumbLink,
} from '../../internal/internal-typography';
import { CompactRow } from '../../layouts/compact_row';
import Divider from './divider';

type ContainerProps = {
  children: React.Node,
};
const Container = (props: ContainerProps) => (
  <CompactRow divider={<Divider />}>{props.children}</CompactRow>
);

type CrumbProps = {
  label: string,
  href: string,
};

const Crumb = (props: CrumbProps) => (
  <BreadcrumbLink href={props.href}>{props.label}</BreadcrumbLink>
);

type CurrentProps = {
  label: string,
};
const Current = (props: CurrentProps) => (
  <BreadcrumbCurrent aria-current="location">{props.label}</BreadcrumbCurrent>
);

type BreadcrumbsProps = {
  crumbs: Array<CrumbProps>,
  current: string,
};

const Breadcrumbs = (props: BreadcrumbsProps) => {
  return (
    <nav aria-label="breadcrumbs">
      <Container>
        {props.crumbs.map((crumbProps: CrumbProps) => (
          <Crumb key={crumbProps.label.toLowerCase()} {...crumbProps} />
        ))}
        <Current label={props.current} />
      </Container>
    </nav>
  );
};

export default Breadcrumbs;
